// extracted by mini-css-extract-plugin
export default {"tag":"TagOutline_tag__rDLun"};